import React from "react";
import { useSelector } from "react-redux";
import SharpUserLogin from "./Sharp/UserLogin";
import UserLogin from "./Default/UserLogin";
const Login = () => {
  const { theme } = useSelector((state) => state.login);
  if (theme) {
    let LoadLogin = theme === "Sharp" ? <SharpUserLogin /> : <UserLogin />;
    return LoadLogin;
  } else {
    return null;
  }
};
export default Login;
